import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import "./also-read.m.css";

export const AlsoRead = ({ element, story, externalLink = false }) => {
  const linkedStories = get(story, ["linked-stories"], {});
  const linkedStoryId = get(element, ["metadata", "linked-story-id"], "");
  const linkedStorySlug = get(linkedStories, [linkedStoryId, "slug"], "");

  const storyUrl = `/${linkedStorySlug}`;

  let text = element.text || "";
  if (externalLink) {
    text = element.text.replace(/<a/g, '<a target="_blank"');
  }

  return (
    <Link href={storyUrl}>
      <div styleName="also-read-wrapper">
        <span styleName="also-read-text">Also Read : </span>
        <span styleName="also-read-link" dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </Link>
  );
};
AlsoRead.propTypes = {
  element: PropTypes.shape({
    text: PropTypes.string
  }),
  story: PropTypes.object,
  externalLink: PropTypes.string
};
